const onboardingManualEmailTemplate = (data) => `
    Full Name: ${data.name}
    Company Name: ${data.companyName}
    Phone: ${data.phone}
    Email: ${data.email}
    Address 1: ${data.address1}
    Address 2: ${data.address2}
    City: ${data.city}
    State: ${data.state}
    Postal Code: ${data.zip}
    Best Time to Call: ${data.dateTimePref}
    Agreed to Terms: ${data.agreeTermsCheckBox === 'on' ? 'Yes' : 'No'}
    Opt-In: ${data.optin === 'on' ? 'Yes' : 'No'}
`;

export default onboardingManualEmailTemplate;
